'use strict';


angular.module('webmailWrapper')
    .controller('LoginCtrl', function(
        $scope,
        tokenManager,
        $timeout,
        expired,
        browserSettings,
        translationProvider,
        entryPointProvider,
    ) {
        var inProgress = false;

        $scope.credentials = {email: '', password: ''};
        $scope.isInvalid = false;
        $scope.expired = expired;
        $scope.cookieEnabled = browserSettings.cookieEnabled();

        $scope.entryPoint = entryPointProvider.entryPoint;
        $scope.logoPath = entryPointProvider.logoPath;

        var loginTemplates = {
            hosting:    require('@/views/login/hosting.html'),
            netcologne: require('@/views/login/netcologne.html'),
            unbranded:  require('@/views/login/unbranded.html'),
        };

        $scope.loginTemplate = loginTemplates.unbranded;
        switch ($scope.entryPoint) {
            case 'hosting.de':
            case 'hosting.fr':
                $scope.loginTemplate = loginTemplates.hosting;
                break;
            case 'netcologne':
                $scope.loginTemplate = loginTemplates.netcologne;
                break;
        }

        var getWebsiteLinks = function() {
            if (entryPointProvider.defaultLang === 'fr_FR') {
                return {
                    main: 'https://www.hosting.fr',
                    webhosting: 'https://www.hosting.fr/herbergement/',
                    domains: 'https://www.hosting.fr/domaines/',
                    server: 'https://www.hosting.fr/serveur/',
                    nextcloud: 'https://www.hosting.fr/nextcloud/',
                    aboutUs: 'https://www.hosting.fr/sur-nous/',
                    career: 'https://www.hosting.fr/sur-nous/carriere/',
                    blog: 'https://www.hosting.fr/blog/',
                }
            }
            return {
                    main: 'https://www.hosting.de',
                    webhosting: 'https://www.hosting.de/webhosting/',
                    domains: 'https://www.hosting.de/domains/',
                    server: 'https://www.hosting.de/server/',
                    nextcloud: 'https://www.hosting.de/nextcloud/',
                    aboutUs: 'https://www.hosting.de/ueber-uns/',
                    career: 'https://www.hosting.de/ueber-uns/karriere/',
                    blog: 'https://www.hosting.de/blog/',
                }
        }

        $scope.hostingLinks = getWebsiteLinks();

        $scope.refresh = function() {
            $scope.cookieEnabled = browserSettings.cookieEnabled();
        };

        function triggerInvalidAnimation() {
            $scope.isInvalid = true;

            $timeout(function () {
                inProgress = false;
                $scope.isInvalid = false;
            }, 550);
        }

        $scope.submit = function(form) {
            if (inProgress) {
                return;
            }
            if (form.$invalid) {
                triggerInvalidAnimation();
                return;
            }
            inProgress = true;

            tokenManager.authenticate($scope.credentials.email, $scope.credentials.password)
                .catch(triggerInvalidAnimation);
        };

        $scope.getPasswordTranslation = function() {
            return translationProvider.instant('TR_050525-1df55d_TR');
        }

        $scope.getEmailTranslation = function() {
            return translationProvider.instant('TR_080119-8dd4a1_TR') + ' (user@example.com)';
        }

        $scope.getGoogleReviewStats = function() {
            return translationProvider.instant('TR_100226-fd727d_TR', undefined, {reviewCount: "116", starCount: "5.0"});
        }

    });
